import { render, staticRenderFns } from "./PopupError.vue?vue&type=template&id=0aa13266"
import script from "./PopupError.vue?vue&type=script&lang=js"
export * from "./PopupError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports